import { Component, OnInit, Input } from '@angular/core';
import { UberFilterDataService } from 'app/solar/common/uber-filter/uber-filter-data.service';
import { UberFilterService } from './uber-filter.service';
import { Observable } from 'rxjs';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { RxComponent } from 'app/core/components/common/rx.component';
import { UberFilterConfig } from './uber-filter-config';


@Component({
  selector: 'itpx-uber-filter',
  templateUrl: './uber-filter.component.html',
  styleUrls: ['./uber-filter.component.css'],
  animations: [
    trigger('openClose',
      [
        state('collapsed', style({ height: '0px' })),
        state('expanded, void', style({ height: '*' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ]),
    trigger('rotate',
      [
        state('collapsed', style({ transform: 'rotate(90deg)' })),
        state('expanded, void', style({ transform: 'rotate(0deg)' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ])]
})
export class UberFilterComponent extends RxComponent {

  filters$: Observable<{}>;
  @Input() url: string;
  @Input() config: {filters: UberFilterConfig[]};
  
  constructor(
    private dataService: UberFilterDataService,
    private operations: UberFilterService
  ) { 
    super();
  }

  ngOnInit() {
    //If congig.mappingCalc=CALC.CLIENT
    let filterMapping$ = this.dataService
    .getData(this.url, null) //get and cache data
    .map(data => this.operations.getFilterMappings(data, this.config.filters)) //create filter mapping
    // .bindToLifecycle(this);

    this.filters$ = filterMapping$.map(it => this.operations.getFilters(it, this.config.filters))
    // this.filters$ = this.dataService.getData(this.url, null).withLatestFrom(filterMapping$)

    
  }

}



// WEBPACK FOOTER //
// ./src/app/solar/common/uber-filter/uber-filter.component.ts